<!-- <p-toast></p-toast> -->

<div class="card dashboardTable">
    <p-table #allFarmerApps [value]="tableData" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'App_ID',
            'VillageCode',
            'AssignedDate'
            ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end"
                [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                <!-- Left side -->
                <div class="col-12 md:col-4">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ tableHeaderName | translate}}
                    </h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-0 md:col-0 d-flex justify-content-center">
                   
                </div>
                <!-- Right side for search -->
                <div class="col-12 md:col-8 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="allFarmerApps.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="exportMenu"></p-menu> -->
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{'S_NO'| translate}}</th>
                <th pSortableColumn="App_ID">{{'APP_ID'| translate}}</th>
                <th pSortableColumn="VillageCode">{{'VILLAGE'| translate}}</th>
                <th pSortableColumn="AssignedDate">{{'SCHEME'| translate}}</th>
                <th>{{'SURVEY_ACTION_PLAN'| translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-val let-ri="rowIndex">
            <!-- <tr class="body-section"> -->
            <tr class="body-section" [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(val)}">
                <td>{{ ri + 1 }}</td>
                <td>{{val?.App_ID}}</td>
                <td>{{val?.VillageCode}}</td>
                <td>{{val?.AssignedDate | date:'mediumDate'}}</td>
                <td>
                    <button 
                        pButton 
                        pRipple 
                        type="button"  
                        label="Assign"
                        (click)="onClickAssign(val)" 
                        class="p-button-rounded p-button-text p-button-success mr-2">
                    </button>
                    <button 
                        pButton pRipple 
                        type="button"  
                        label="Re-Assign"
                        (click)="onClickReAssign(val)" 
                        class="p-button-rounded p-button-text p-button-danger">
                    </button>
                </td>
            </tr>
        </ng-template>

        <!-- <ng-template pTemplate="summary">
            <div class="flex  justify-content-between flex-column ">
                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{tableData ?
                    tableData.length : 0 }} {{'RECORDS_ADDED'| translate}}
                </p>
                <div class="flex  justify-content-between flex-column "> 
                    <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APPROVED' | translate}}</div>
                    <div class="flex"><div style="background-color:#ffffc5 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING' | translate}}</div>
                    <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'RETUREN_PROCESS' | translate}}</div>
                    <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'REJECTED' | translate}}</div>
                </div>
            </div>
        </ng-template> -->

    </p-table>
</div>

<p-confirmDialog>
    <ng-template pTemplate="message" let-message>
        <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
            <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
        </div>
    </ng-template>
</p-confirmDialog>

<p-dialog header="Re-Assign Survey" [modal]="true" [(visible)]="openReAssignDialog" [style]="{ width: '25rem' }" (onHide)="onCloseReAssignDialog()">
    <span class="p-text-secondary block mb-5">Update Survey Date</span>
    <div class="flex align-items-center gap-3 mb-3 reAssign-box">
        <label for="username" class="font-semibold w-6rem">{{ 'APP_ID' | translate}}</label>
        <p>{{ reAssignAppId }}</p>
        <!-- <input readonly id="username" class="flex-auto" [(ngModel)]="reAssignAppId" autocomplete="off" /> -->
    </div>
    <div class="flex align-items-center gap-3 mb-5">
        <label for="email" class="font-semibold w-6rem">New Date</label>
        <p-calendar [disabled]="false" [minDate]="nextDate" [showIcon]="true" [showButtonBar]="true"
            dateFormat="dd-mm-yy" [(ngModel)]="reassignDate" appendTo="body"></p-calendar>
    </div>
    <div class="flex justify-content-end gap-2">
        <p-button label="Cancel" severity="secondary" (onClick)="openReAssignDialog = false"></p-button>
        <p-button [disabled]="!reassignDate" label="Save" (onClick)="onConfirmReAssign()"></p-button>
    </div>
</p-dialog>